export default __webpack_public_path__ + "static/media/54.7705278c.png";